import React from "react";
import { OrganizationReportCard } from "./OrganizationReportCard";
import { OrganizationReportUIProvider } from "./OrganizationReportUIContext";

export function OrganizationReportPage({ history, match }) {
  const organizationReportUIEvents = {
    openDetailOrganizationReportPage: id => {
      history.push(`/admin/report/organization/${id}/detail`);
    }
  };

  return (
    <OrganizationReportUIProvider
      organizationReportUIEvents={organizationReportUIEvents}
    >
      <OrganizationReportCard history={history} match={match} />
    </OrganizationReportUIProvider>
  );
}
